// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Bufr","placeholdersHeader":"styles_placeholdersHeader__2sw27","editorStyle":"styles_editorStyle__q4Tkg","placeholdersBox":"styles_placeholdersBox__313X_"};